"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reYYYYMMDD = exports.reMMDDYYYY = void 0;
exports.reMMDDYYYY = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
exports.reYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/;
//# sourceMappingURL=dates.js.map